import type { FaireProductEntity } from "../../entity_types/product";

export const p_2fcbvc3c2q: FaireProductEntity = {
  token: "p_2fcbvc3c2q",
  type: "product",
  name: "Mindfulness for Every Day: 52 Beautiful Cards",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/3c448502e5f862b3c7196d8446e0052e9f8c351fd3b2104b80c5d3642e84cc3c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/44bded6655dc4fca879071d0b64700efef7d09478a0c05094549c45b7bb209aa.jpeg",
    "https://cdn.faire.com/fastly/3c42a9b5616fe363c870a01c388cebaffbdf20c630c33ab41577c900f1f20da7.jpeg",
    "https://cdn.faire.com/fastly/642f31304db5147d998cbda0632a1af4a2fbd39773a4e11899a5db2d6c578567.jpeg",
    "https://cdn.faire.com/fastly/b67db0b85147f9a3a5304280feeb5517379537931e9d0ecaaa9093fe731599d9.jpeg"
  ],
  priceDollars: 6,
  description: "Pause, take a deep breath and get grounded in the present moment... Invite peace into your life with this calming card deck.\n\nMindfulness is the key to unlocking daily peace and gratitude. When we practice mindfulness, we connect with the world around us, become open to new experiences and enjoy a state of calm and contentment. Embark on a journey to living more mindfully with this pocket-sized self-care companion.\n\nComplete with 52 cards and an 8-page booklet, this beautiful deck is designed to help you create mindful moments every day. Each card details thoughtful advice, a simple tip or a relaxation ritual; turn the cards over to reveal inspiring quotes to ground your daily mindfulness practice.\n\nShuffle the deck and discover:\n- Breathing techniques to help you relax\n- Self-care practices to break up your busy schedule\n- Simple tips and tricks to keep you in the present moment\nAnd much more!\n\nBy following the advice on these cards, you can live a calmer, happier, more mindful life.",
  tags: [],
  msrpDollars: 11.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:58.314Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
